/**
 * Created by mykurisu on 2017/6/12.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import '../../styles/lecture/LectureLecturers.css'

class LecturerOne extends Component {

    handleLecturerSetShow() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_LECTURER_DIALOG',
            payload: {lectureIndex: this.props.index}
        });
    }

    render() {
        const {role, isRelay} = this.props;
        const {liveroom} = this.props.lecture;
        return (
            <div className="lecture-lecturerone">
                <a href={`/liveroom/${liveroom.id}`}>
                    <div className="lecture-lecturerone-icon">
                        <img src={this.props.content.account.avatar_url} alt=""/>
                    </div>
                </a>
                <div className="lecture-lecturerone-text" style={{paddingRight: role.is_manager && !isRelay ? '40px' : '0'}}>
                    <p>{this.props.content.account.nickname}&nbsp;&nbsp;<span>{this.props.content.title}</span></p>
                    <pre>{this.props.content.introduction}</pre>
                </div>
                {role.is_manager && !isRelay &&
                <div className="lecture-lecturerone-btn" onClick={this.handleLecturerSetShow.bind(this)}>
                    <i className="iconfont icon-gengduo1 lecture-lecturerone-btn_i" style={{fontSize: '24px'}}/>
                </div>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    lecture: state.lecture,
    role: state.lecture.role,
    isRelay: state.lecture.lecture.is_relay,
}))(LecturerOne)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureLecturersRecord.js